import EditRubricTagModal from "./EditRubricTagModal";

export default EditRubricTagModal;
